module.exports = __webpack_public_path__ + "static/work_icon_recruiting-ef734b997fd2a464a3983976c358ad6d.png";